import React from 'react';

import ContentCaseBottom from './content-case-bottom';
import ContentCaseHeader from './content-case-header';
import ContentCaseMiddle from './content-case-middle';
import FullWrapper from '../../../../../core/FullWrapper';
import Image from 'next/image';
import { Typography } from '../../../../../core/Typography';

const CardIcon = ({ title, image }) => {
    return (
        // eslint-disable-next-line max-len
        <div className="gap-[16px] flex">
            {image && (
                <div className={'size-[30px] min-w-[30px] min-h-[30px] relative'}>
                    <Image fill src={`${image}`} alt={title || ''} objectFit={'contain'} />
                </div>
            )}

            <Typography
                variant="div"
                className="mobile:text-[24px]! text-[18px]! leading-[140%]! mobile:leading-[150%]!"
            >
                <div dangerouslySetInnerHTML={{ __html: title }} />
            </Typography>
        </div>
    );
};

const ContentCase = ({ caseName, listTitle, bottomPicture }) => {
    return (
        <FullWrapper className={caseName}>
            <div>
                <ContentCaseHeader listTitle={listTitle} />
                <div className="flex gap-[40px] flex-col desktop:flex-row">
                    <div className="desktop:w-8/12">
                        <ContentCaseMiddle listTitle={listTitle} />
                        {listTitle[0].company ? (
                            <ContentCaseBottom
                                bottomPicture={bottomPicture}
                                listTitle={listTitle}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="desktop:w-4/12">
                        <div className="border-l-[4px] border-text-accent-cold pl-[24px] flex flex-col gap-[40px] desktop:gap-[60px]">
                            <div className="max-w-[243px] aspect-[243/34] relative">
                                <Image
                                    fill
                                    src={`/images/pic/talent-mind/tagline.png`}
                                    alt={'tagline'}
                                    objectFit={'contain'}
                                />
                            </div>
                            <div className="flex gap-[10px] flex-col">
                                <CardIcon
                                    title={'Лучший проект <br/> для digital-индустрии (2025)'}
                                    image="/images/pic/talent-mind/medal-tagline-awards-2025-silver.svg"
                                />
                                <CardIcon
                                    title={'Лучший продукт года<br/>среди агентств (2025)'}
                                    image="/images/pic/talent-mind/medal-tagline-awards-2025-silver.svg"
                                />
                                <CardIcon
                                    title={'Лучший сервис агентств<br/>для новых условий (2025)'}
                                    image="/images/pic/talent-mind/medal-tagline-awards-2025-bronze.svg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FullWrapper>
    );
};
export default ContentCase;
